import { render } from "./LandGIS.vue?vue&type=template&id=a1036358&scoped=true"
import script from "./LandGIS.vue?vue&type=script&lang=js"
export * from "./LandGIS.vue?vue&type=script&lang=js"

import "./LandGIS.vue?vue&type=style&index=0&id=a1036358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1036358"]])

export default __exports__